import axios from 'axios'
import {
  Message,
  MessageBox,
  Notification
} from 'element-ui'
import store from '@/store'
import storage from 'good-storage'
import {
  getToken
} from './auth'

// create an axios instance
const service = axios.create({
  // headers: { 'Access-Control-Allow-Origin': '*' },
  baseURL: process.env.NODE_ENV === 'production'? process.env.IMG_URL:'', // 如果是生产模式，这用配置;如果是开发环境，就用代理
  // baseURL: process.env.IMG_URL,
  timeout: 50000 // request timeout
})

// request拦截器
service.interceptors.request.use(config => {
  // console.log(config)
  // Do something before request is sent
  // 如果vuex中含有token
  if (getToken()) {
    // 获取cookie中的token，并且放到请求的头中
    config.headers.Authorization = getToken() // 让每个请求携带token--['X-Token']为自定义key 请根据实际情况自行修改
  } else
    {
      config.headers.Authorization = ''
    }
  return config
}, error => {
  // Do something with request error
  // console.log(error) // for debug
  Promise.reject(error)
})

service.interceptors.response.use(
  response => {
    /**
     * 下面的注释为通过response自定义code来标示请求状态，当code返回如下情况为权限有问题，登出并返回到登录页
     * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
     */
    const res = response.data
    if (res.status !== 200) {
      Message({
        message: res.message,
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(res.message)
    } else {
      return response.data
    }
  },
  error => {
    // 在这儿可跳转404页面
    // console.log('err' + error) // for debug
    const response = error.response
    if (response === undefined) {
      Message({
        message: '服务请求超时！',
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(error)
    }
    const info = response.data
    if (response.status === 401 || info.status === 40101) {
      // MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
      //   confirmButtonText: '重新登录',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(() => {
      //   store.dispatch('LogOut').then(() => {
      //     location.reload() // 为了重新实例化vue-router对象 避免bug
      //   })
      // })
      return Promise.reject(error)
    }
    if (response.status === 403) {
      Notification.warning({
        title: '禁止',
        message: info.message,
        type: 'error',
        duration: 2 * 1000
      })
      return Promise.reject(error)
    }
    if (info.status === 30101) {
      Notification.warning({
        title: '失败',
        message: info.message,
        type: 'error',
        duration: 2 * 1000
      })
      return Promise.reject(error)
    }
    if (response.status === 504) {
      Message({
        message: '后端服务异常，请联系管理员！',
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(error)
    }
    Message({
      message: info.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/common/js/requestToGetFile.js